$(document).ready(function() {
  function markAsRead(notificationId) {
    var url = '/api/notifications/' + notificationId + '/read'
    $.ajax({
      type: 'POST',
      url: url
    });
  }

  function markAsSeen(notificationUuids) {
    var url = '/api/notifications/seen_all'
    $.ajax({
      type: 'POST',
      url: url,
      data: {
        uuids: notificationUuids
      }
    });
  }

  function attachNotificationStatusUpdateEvent() {
    $(".js-notification:not(.js-rendered) .js-notification-status").click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      var uuid = $(this).parent().data('id');
      $(this).parent().removeClass(' nav-notification__bullet--unread');
      // set the notification as read in the database
      markAsRead(uuid);
    });
  }

  function attachNotificationClickEvent() {
    $(".js-notification:not(.js-notification-status)" ).click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      // set the notification as read
      var uuid = $(this).data('id');
      markAsRead(uuid);
      $(this).removeClass('notification--unread');

      // send the user to the url if there's one
      var url = $(this).find("a").attr("href");
      if (url != undefined) {
        window.location = url;
        return false;
      }
    });
  }

  window.renderNotifications = function(){
    attachNotificationStatusUpdateEvent();
    attachNotificationClickEvent();

    // add an extra class indicating that the element has been rendered by javascript
    // This should always be the last line of renderNotifications();
    $(".notification:not(.js-rendered)").addClass('js-rendered');
  }

  // when you click the bell icon or the dot
  // we should fetch the latest notifications with ajax
  $('.js-notifications-open').click(function() {
    $.ajax({
      type: 'GET',
      url: '/notifications/dropdown_notifications',
      data: {
        v2: $('body').hasClass('js-application-v2')
      }
    }).done(function(content) {
      $('#notificationsDropdownList').html(content);
      renderNotifications();
      $('.notification-dropdown--unseen').hide();
    });
  });

  var notifications_fetched = false;

  $('.js-notifications-open-bell').mouseenter(function(){
    if (notifications_fetched === false) {
      fetch_notifications();
      notifications_fetched = true;
    }
  });

  function fetch_notifications() {
    $.ajax({
      type: 'GET',
      url: '/notifications/dropdown_notifications',
      data: {
        v2: $('body').hasClass('js-application-v2')
      }
    }).done(function(content) {
      $('#notifications_dropdown_list').html(content);
      renderNotifications();
      $('.nav-notifications__badge').hide();
    });
  }
  renderNotifications();

  document.addEventListener("js-notifications-loaded", function() {
    $('.dc-notification__timestamp').timeago();
    attachNotificationStatusUpdateEvent();
    attachNotificationClickEvent();
    $('.js-nav-item a.header-user').hover(function() {
      var uuids = $('.js-notification').map(function(li) {
        uuid = $(this).data('id');
        markAsRead(uuid);
        return uuid;
      })
      markAsSeen(uuids.toArray());
    })
  })
});
